import { httpClient } from '@alfa-bank/site-http-client';
import { DADATA_PROXY_SUGGEST_FIO } from '@alfa-bank/site-envconfig';

import type { TNames, TGenders, ISuggestionsItem } from '../models';

const url = DADATA_PROXY_SUGGEST_FIO();

const headers = {
    Accept: 'application/json',
};

const dataVocabulary = {
    lastName: 'SURNAME',
    firstName: 'NAME',
    middleName: 'PATRONYMIC',
};

export const getSuggestions = async (name: TNames, query: string, gender?: TGenders) => {
    try {
        const res = await httpClient.post<{ suggestions: ISuggestionsItem[] }>(
            url,
            {
                query,
                parts: [dataVocabulary[name]],
                gender,
            },
            { headers }
        );

        const { data } = res;
        const { suggestions } = data;

        return suggestions.map((suggestion, id) => ({
            id,
            gender: suggestion?.data?.gender,
            label: suggestion.value,
        }));
    } catch (err: any) {
        throw new Error(err);
    }
};
